"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilenameFromKey = void 0;
/**
 * Get filename from pre-signed link key
 * @param key
 */
var getFilenameFromKey = function (key) {
    return key.split('/')[key.split('/').length - 2] || key;
};
exports.getFilenameFromKey = getFilenameFromKey;
